export async function generateSkillPath(answers) {
  const response = await fetch('/api/skill-path', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ answers }),
  });
  if (!response.ok) throw new Error('Failed to generate skill path');
  return response.json();
}
